import {useEffect} from "react";

const useHeadline = (headline, element) => {
  useEffect(() => {
    headline.set(element);
    return () => headline.set(null);
  }, []);
};

export default useHeadline;